module.exports = __webpack_public_path__ + "static/media/info.13836bd7.svg";